import { CmsConfig } from "./../../../typings";
import { SubGroupConfiguration, MainGroupConfiguration } from "../../../data";

export const cmsConfig: CmsConfig = {
    ShowTeamNameML: false,
    MainGroupBy: MainGroupConfiguration.Sport,
    SubGroupBy: SubGroupConfiguration.League,
    ExpandedGroupItems: 2,
    ExpandedEvents: 1,
    ShowSportEventsCount: true,
    ShowLeaguesEventsCount: true,
    ShowLivePhraseBeforeSportName: true,
    ShowSortingFilter: true,
    BlockId: "BlockId",
    BetRadarStatisticClientId: "1235",
    NumberOfSelectionsToShow: 5,
    EventsCount: 7,
    ShowViewAllLive: false,
    ShowLeagueInEventCard: true,
    ShowLiveFixturesAndOutrights: true
};